<script>
    import { url } from '@sveltech/routify'
    import { DataTable } from 'totalinvoice-frontend-core'
    import { t, dt, languageStore } from 'totalinvoice-frontend-core'

    export let invoiceList
    export let searchable
    export let sortable

    const dateFormatter = (id, col, value) => $dt(new Date(value))
    const linkFormatter = (id, col, value) => `<a href="${$url(`/customer/invoices/download/${id}`)}">${value}</a>`

    let columns = [
        {
            label: 'ID', // Column name
            field: 'id', // Field name from row
            visible: false,
            numeric: false, // Affects sorting
            formatter: null
        },
        // Array of objects
        {
            label: 'Date', // Column name
            field: 'date', // Field name from row
            visible: true,
            numeric: false, // Affects sorting
            formatter: dateFormatter
        },
        {
            label: 'File', // Column name
            field: 'filename', // Field name from row
            visible: true,
            numeric: false, // Affects sorting
            formatter: linkFormatter
        }
    ]

    $: if ($languageStore.selected) {
        columns = columns // force data table to re-render if language has changed
    }
</script>

{#if invoiceList && invoiceList.length > 0}
    <DataTable rowKey="id" {columns} rows={invoiceList} {searchable} {sortable} />
{:else}
    <div class="has-text-centered pt-5">
        <p>
            <span class="icon is-large has-text-grey-light">
                <i class="fas fa-file-invoice fa-5x" />
            </span>
        </p>
        <h5 class="subtitle is-5 mt-3">{$t('No invoices found')}</h5>
    </div>
{/if}
